import type { Components, Theme } from "@mui/material/styles";

export const MuiOutlinedInput: Components<Theme>["MuiOutlinedInput"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      borderRadius: theme.shape.borderRadius,
    }),

    notchedOutline: ({ theme, label }) => ({
      // even if shrink hasn't been set, we should shrink on focus
      ".Mui-focused > &, .MuiInputLabel-shrink ~ .MuiOutlinedInput-root > &": {
        "& legend": {
          maxWidth: "100%",

          "& > span": {
            maxWidth: "100%",
            padding: label ? theme.spacing(0, 0.5) : 0,
          },
        },
      },
    }),
  },
};
